import "./rails-ujs";
import "./turbolinks";
import "./sitewide/google_tagmanager";
import "bootstrap/dist/js/bootstrap";

global.$ = global.jQuery = require("jquery");
